export function reapplyAlternatingRows() {
  const visible = Array.from(document.querySelectorAll("li.header-result")).filter(
    el => !el.classList.contains("filtered-hidden") && !el.classList.contains("d-none") && el.style.display !== "none"
  )
  visible.forEach((el, i) => {
    el.classList.toggle("row-even", i % 2 === 0)
  })
}
